module.exports = __webpack_public_path__ + "assets/41f767350f7fc5ab12ea15335224129b.ttf";